import {Observable} from 'rxjs';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {Filter, SimpleSeries, SimpleUnit, ThresholdStatic} from '@core/interfaces/system/system-common';
import {LatestModelStatus} from '@core/interfaces/live/live';

export interface ThicknessRateUnits {
    lengthUnit: SimpleUnit;
    rateUnit: SimpleUnit;
}

export interface ThicknessRateDashboardData {
    data: SimpleSeries<Date, number>;
    thresholds: ThresholdStatic[];
}

export abstract class ThicknessRateService {
    abstract getThicknessRateUnits(): Observable<ThicknessRateUnits>;

    abstract getThicknessRateDatasource(id: string, filter: Filter[]): Observable<DataSource>;

    abstract getCountResults(id: string, uploadTime?: string): Observable<number>;

    abstract getThicknessRateLatestModelStatus(id: string, uploadTime?: string): Observable<LatestModelStatus>;

    abstract getThicknessRateDashboardData(
        chart: string,
        id: string,
        uploadTime?: string,
    ): Observable<ThicknessRateDashboardData>;
}
